import { render, staticRenderFns } from "./XJDataV.vue?vue&type=template&id=28bbbd4d&scoped=true&"
import script from "./XJDataV.vue?vue&type=script&lang=js&"
export * from "./XJDataV.vue?vue&type=script&lang=js&"
import style0 from "./XJDataV.vue?vue&type=style&index=0&id=28bbbd4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bbbd4d",
  null
  
)

export default component.exports